import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { base44 } from "@/api/base44Client";

export default function NewsletterSignup({ compact = false }) {
  const [email, setEmail] = React.useState("");
  const [status, setStatus] = React.useState("idle");

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus("saving");
    try {
      await base44.entities.EmailLead.create({
        email,
        source: "daily_sailing_briefing_signup",
        interest: "daily_briefing",
        status: "new",
        consent: true,
        captured_at: new Date().toISOString(),
      });
      setEmail("");
      setStatus("saved");
    } catch {
      setStatus("error");
    }
  };

  return (
    <section className="rounded-3xl border border-border bg-card/90 p-6 shadow-xl shadow-ocean/5 md:p-8">
      <div className={compact ? "space-y-4" : "grid gap-5 md:grid-cols-[1fr_auto] md:items-end"}>
        <div>
          <p className="text-sm font-bold uppercase tracking-[0.18em] text-primary">Free daily sailing briefing</p>
          <h2 className="mt-2 font-heading text-2xl font-black text-foreground">Get a quick win before you subscribe.</h2>
          <p className="mt-2 text-muted-foreground">Weather alerts, departure reminders, marina updates, and voyage-planning tips.</p>
        </div>
        <form className="flex w-full flex-col gap-3 sm:flex-row md:w-[28rem]" onSubmit={handleSubmit}>
          <Input type="email" required value={email} onChange={(event) => setEmail(event.target.value)} placeholder="Email address" aria-label="Email address" className="bg-background" />
          <Button type="submit" disabled={status === "saving"} className="whitespace-nowrap">{status === "saving" ? "Saving..." : "Get briefing"}</Button>
        </form>
        {status === "saved" && <p className="text-sm font-bold text-primary md:col-span-2">You’re on the list — we’ll use this for free briefings and upgrade follow-up.</p>}
        {status === "error" && <p className="text-sm font-bold text-destructive md:col-span-2">Couldn’t save that email. Please try again.</p>}
      </div>
    </section>
  );
}